var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotePad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18686 3.50162L5.68687 3.50836C4.28674 3.51105 3.58667 3.5124 3.05242 3.78591C2.58248 4.0265 2.20076 4.40969 1.96199 4.88055C1.69053 5.41586 1.69188 6.11592 1.69457 7.51605L1.70805 14.516C1.71075 15.9162 1.71209 16.6162 1.98561 17.1505C2.22619 17.6204 2.60938 18.0021 3.08025 18.2409C3.61555 18.5124 4.31561 18.511 5.71574 18.5083L12.7157 18.4949C14.1159 18.4922 14.8159 18.4908 15.3502 18.2173C15.8201 17.9767 16.2018 17.5935 16.4406 17.1227C16.7121 16.5874 16.7107 15.8873 16.708 14.4872L16.7013 10.9872M6.70609 13.5064L8.10154 13.5037C8.50919 13.5029 8.71302 13.5025 8.90474 13.4561C9.07472 13.415 9.23717 13.3473 9.38611 13.2557C9.55411 13.1523 9.69796 13.0079 9.98565 12.719L17.9393 4.73477C18.6283 4.04309 18.6261 2.9238 17.9344 2.23478C17.2428 1.54575 16.1235 1.5479 15.4344 2.23959L7.48083 10.2239C7.19313 10.5127 7.04928 10.6571 6.94653 10.8255C6.85544 10.9748 6.78841 11.1375 6.74791 11.3076C6.70223 11.4995 6.70262 11.7033 6.70341 12.111L6.70609 13.5064Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePad);
export default __webpack_public_path__ + "static/media/note-pad.5e2e1e83f3b01906a774a21b0fab1357.svg";
export { ForwardRef as ReactComponent };